<template>
    <div>
        <div class="relative">
            <div v-if="showColor" class="absolute p1">
                <v-swatches
                    v-model="colorRef"
                    popover-x="left"
                    swatches="text-advanced"
                    inline
                    @input="selectColorRef"
                >
                </v-swatches>
            </div>
        </div>
        <custom-input
            v-model="color"
            :label="label"
            :disabled="!enabled"
            @blur="changeColor"
            @input="lowerColor"
            @click-icon="
                () => {
                    if (enabled) {
                        showColor = !showColor;
                    }
                }
            "
        >
            <template #icon>
                <span
                    class="rounded"
                    :style="{
                        'background-color': colorRef
                    }"
                >
                    🎨
                </span>
            </template>
        </custom-input>
    </div>
</template>

<script>
import VSwatches from "vue-swatches";
import "vue-swatches/dist/vue-swatches.css";

import { allColors } from "@/common/fields/colors";

import CustomInput from "@/components/utils/CustomInput.vue";

export default {
    name: "ColorInput",
    components: {
        CustomInput,
        VSwatches
    },
    model: {
        prop: "itemCurrent",
        event: "change"
    },
    props: {
        itemCurrent: {
            default: () => ({ color: "blanco", colorRef: "#fff" }),
            type: Object,
            require: true
        },
        enabled: {
            default: () => true,
            type: Boolean,
            required: false
        },
        label: {
            default: "Color",
            type: String,
            required: false
        }
    },
    emits: ["change"],
    data: () => ({
        color: "blanco",
        colorRef: "#fff",
        showColor: false
    }),
    watch: {
        itemCurrent(value) {
            this.setValue(value);
        }
    },
    mounted() {
        this.setValue(this.itemCurrent);
    },
    methods: {
        lowerColor() {
            this.color = this.color.toLowerCase();
        },
        hideColor() {
            this.showColor = false;
        },
        selectColorRef() {
            this.color = allColors[this.colorRef];
            this.showColor = false;
            this.changeColor();
        },
        changeColor() {
            this.$emit("change", {
                color: this.color,
                colorRef: this.colorRef
            });
        },
        setValue(value) {
            this.color = value.color;
            this.colorRef = value.colorRef;
        }
    }
};
</script>

<style scoped>
.p1 {
    top: -12.5rem;
    right: 0;
    z-index: 20000;
}
</style>
